module.exports = __webpack_public_path__ + "img/m15.9783dd0.jpg";